import { InputAdornment, MuiThemeProvider, TextField } from '@material-ui/core';
import { customizerTheme } from 'assets/theme';
import { WithStyles } from 'decorators/withStyles';
import { ILanguageBar } from 'interfaces/theme';
import * as React from 'react';
import { PureComponent } from 'react';
import rxjsOperators from 'rxjs-operators';
import themeCustomizerService from 'services/themeCustomizer';

import ColorPicker from './ColorPicker';

interface IProps {
  classes?: any;
}

interface IState {
  model: ILanguageBar;
}
@WithStyles(() => ({
  opacity: {
    '& input': {
      textAlign: 'right'
    }
  }
}))
export default class LanguageSelectBar extends PureComponent<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = { model: null };
  }

  componentDidMount() {
    themeCustomizerService
      .getData()
      .pipe(
        rxjsOperators.logError(),
        rxjsOperators.bindComponent(this),
        rxjsOperators.map(model => model.languageBar)
      )
      .subscribe(model => {
        this.setState({ model });

        if (!model.opacity) {
          themeCustomizerService.setData({
            languageBar: {
              ...model,
              opacity: 100
            }
          });
        }
      });
  }

  updateAlphaColor(color: string, opacity: number) {
    let splittedColor = color.split(',');
    const alpha = opacity / 100;

    splittedColor[3] = ' ' + alpha + ')';

    return splittedColor.join(',');
  }

  onChangeBackground = (color: string) => {
    themeCustomizerService.setData({
      languageBar: {
        ...this.state.model,
        bgColor: this.updateAlphaColor(color, this.state.model.opacity)
      }
    });
  };

  onChangeFontColor = (color: string) => {
    themeCustomizerService.setData({
      languageBar: {
        ...this.state.model,
        font: {
          ...this.state.model.font,
          color
        }
      }
    });
  };

  onChangeOpacity = (event: any) => {
    const opacity = Number(event.target.value) > 100 ? 100 : Number(event.target.value);

    themeCustomizerService.setData({
      languageBar: {
        ...this.state.model,
        opacity,
        bgColor: this.updateAlphaColor(this.state.model.bgColor, opacity)
      }
    });
  };

  render() {
    const { model } = this.state;
    const { classes } = this.props;

    if (!model) {
      return null;
    }

    return (
      <MuiThemeProvider theme={customizerTheme}>
        <ColorPicker value={model.bgColor} label="Cor do Fundo" handleChangeColor={this.onChangeBackground} RGBFormat />
        <ColorPicker label="Cor das Letras" value={model.font.color} handleChangeColor={this.onChangeFontColor} />
        <TextField
          label="Opacidade"
          id="opacity"
          value={model.opacity}
          onChange={this.onChangeOpacity}
          type="number"
          margin="normal"
          fullWidth
          InputProps={{
            endAdornment: <InputAdornment position="end">%</InputAdornment>,
            disableUnderline: true,
            className: classes.opacity
          }}
          inputProps={{
            type: 'number',
            min: 0,
            max: 100
          }}
        />
      </MuiThemeProvider>
    );
  }
}
